import { Alignments } from './tableRecords';
export const MOBILE_CELL_BLOCK_SIZE = '2rem !important';
export const DESKTOP_CELL_BLOCK_SIZE = '2.9rem !important';
export const getCellBlockSize = isMobile => isMobile ? MOBILE_CELL_BLOCK_SIZE : DESKTOP_CELL_BLOCK_SIZE;
export const convertToTextAlign = align => align === Alignments.left ? 'start !important' : align === Alignments.right ? 'end !important' : undefined;